import AirlineTag from "./AirlineTag";
import CustomerTag from "./CustomerTag";
import FlightDatesTag from "./FlightDatesTag";
import PaxTag from "./PaxTag";
import PaymentMethodTag from "./PaymentMethodTag";
import PnrTag from "./PnrTag";
import RestTag from "./RestTag";
import SaTag from "./SaTag";
import SaleDateTag from "./SaleDateTag";
import SaleTypeTag from "./SaleTypeTag";
import SrcTag from "./SrcTag";
import SupTag from "./SupTag";
import TktTag from "./TktTag";

const TagsByType = {
  airline: AirlineTag,
  customer: CustomerTag,
  flightDates: FlightDatesTag,
  pax: PaxTag,
  paymentMethod: PaymentMethodTag,
  pnr: PnrTag,
  rest: RestTag,
  sa: SaTag,
  saleDate: SaleDateTag,
  src: SrcTag,
  sup: SupTag,
  tkt: TktTag,
  type: SaleTypeTag,
};

export default TagsByType;
